(function () {
  if (window.ZareVont) return;

  var fmt = function (cents) {
    var formato = window.zvMoneda || '{{amount_with_comma_separator}} €';
    var dos = (cents / 100).toFixed(2);
    var ent = String(Math.round(cents / 100));
    var sep = function (s, miles, dec) { var p = s.split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles); return p.join(dec); };
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount': return sep(dos, ',', '.');
        case 'amount_no_decimals': return sep(ent, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return sep(ent, '.', ',');
        case 'amount_with_space_separator': return sep(dos, ' ', ',');
        case 'amount_with_period_and_space_separator': return sep(dos, ' ', '.');
        case 'amount_with_apostrophe_separator': return sep(dos, "'", '.');
        default: return sep(dos, '.', ',');
      }
    });
  };

  var track = function (evento, datos) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: evento }, datos));
    } catch (e) {}
  };

  var addToCart = function (variantId, cantidad, ir, boton) {
    var drawer = document.querySelector('cart-drawer');
    var payload = { items: [{ id: Number(variantId), quantity: cantidad || 1 }] };
    if (drawer && !ir && typeof drawer.getSectionsToRender === 'function') {
      payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      payload.sections_url = window.location.pathname;
    }
    if (boton) boton.setAttribute('aria-busy', 'true');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Error');
        track('zv_add_to_cart', { variant_id: variantId, quantity: cantidad || 1 });
        if (ir) { window.location.href = '/checkout'; return; }
        if (!drawer) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return; }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zarevont', productVariantId: variantId, cartData: res });
        }
        var estado = Object.assign({}, res, { id: variantId });
        drawer.renderContents(estado);
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
      })
      .catch(function (e) {
        var root = boton && boton.closest('[data-zv-producto]');
        var err = root && root.querySelector('[data-zv-error]');
        if (err) { err.textContent = e.message; err.hidden = false; }
        else alert(e.message);
      })
      .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
  };

  var initProducto = function (root) {
    if (root.dataset.zvIniciado) return;
    root.dataset.zvIniciado = '1';
    var datos = JSON.parse(root.querySelector('[data-zv-variantes]').textContent);
    var unidad = datos.length ? datos[0].price : 0;
    var hidden = root.querySelector('[data-zv-id]');
    var precio = root.querySelector('[data-zv-precio]');
    var tachado = root.querySelector('[data-zv-tachado]');
    var etiquetas = document.querySelectorAll('[data-zv-btn-precio]');
    var botones = document.querySelectorAll('[data-zv-comprar]');
    var plantilla = root.dataset.zvTextoBoton || 'Añadir al carrito · [[precio]]';

    var actual = function () {
      var marcado = root.querySelector('input[name="zv-pack-' + root.dataset.zvSeccion + '"]:checked');
      var id = marcado ? Number(marcado.value) : Number(hidden.value);
      return datos.filter(function (v) { return v.id === id; })[0] || datos[0];
    };

    var pintar = function () {
      var v = actual();
      if (!v) return;
      hidden.value = v.id;
      if (precio) precio.textContent = fmt(v.price);
      var n = v.n || 1;
      var suelto = unidad * n;
      if (tachado) {
        if (n > 1 && suelto > v.price) { tachado.textContent = fmt(suelto); tachado.hidden = false; }
        else { tachado.hidden = true; }
      }
      etiquetas.forEach(function (el) { el.textContent = fmt(v.price); });
      botones.forEach(function (b) {
        b.disabled = !v.available;
        var t = b.querySelector('[data-zv-btn-texto]');
        if (t && b.dataset.zvPrincipal) t.textContent = v.available ? plantilla.replace('[[precio]]', fmt(v.price)) : 'Agotado';
      });
      var url = new URL(window.location.href);
      if (root.dataset.zvEnProducto === 'true') { url.searchParams.set('variant', v.id); window.history.replaceState({}, '', url.toString()); }
    };

    root.querySelectorAll('.zv-pack input').forEach(function (inp) {
      inp.addEventListener('change', function () { pintar(); track('zv_select_pack', { variant_id: inp.value }); });
    });

    botones.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var v = actual();
        if (!v || !v.available) return;
        if (b.dataset.zvScroll === 'true' && !b.dataset.zvPrincipal) {
          var destino = root.querySelector('.zv-packs') || root;
          destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        addToCart(v.id, 1, b.dataset.zvAccion === 'checkout', b);
      });
    });

    var pista = root.querySelector('.zv-galeria__pista');
    var thumbs = root.querySelectorAll('.zv-thumb');
    if (pista && thumbs.length) {
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          pista.scrollTo({ left: pista.clientWidth * i, behavior: 'smooth' });
          var fila = t.parentElement;
          fila.scrollTo({ left: Math.max(0, t.offsetLeft - t.offsetWidth), behavior: 'smooth' });
        });
      });
      var marcar = function () {
        var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth));
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      };
      var tm;
      pista.addEventListener('scroll', function () { clearTimeout(tm); tm = setTimeout(marcar, 60); }, { passive: true });
    }

    pintar();
  };

  var initSticky = function () {
    var sticky = document.querySelector('[data-zv-sticky]');
    var objetivo = document.querySelector('[data-zv-comprar][data-zv-principal]');
    if (!sticky || !objetivo || !('IntersectionObserver' in window)) return;
    var drawer = document.querySelector('cart-drawer');
    var fueraDeVista = false;
    var actualizar = function () {
      var abierto = drawer && drawer.classList.contains('active');
      sticky.classList.toggle('visible', fueraDeVista && !abierto);
    };
    new IntersectionObserver(function (entradas) {
      var e = entradas[0];
      fueraDeVista = !e.isIntersecting && e.boundingClientRect.top < 0;
      actualizar();
    }).observe(objetivo);
    if (drawer) new MutationObserver(actualizar).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  };

  var initPanel = function () {
    document.querySelectorAll('[data-zv-panel-abrir]').forEach(function (b) {
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      if (!panel) return;
      var cerrar = function () { panel.classList.remove('abierto'); b.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; b.focus(); };
      b.addEventListener('click', function () { panel.classList.add('abierto'); b.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; var c = panel.querySelector('[data-zv-panel-cerrar]'); if (c) c.focus(); });
      panel.querySelectorAll('[data-zv-panel-cerrar], .zv-panel__fondo').forEach(function (c) { c.addEventListener('click', cerrar); });
      panel.addEventListener('keyup', function (e) { if (e.key === 'Escape') cerrar(); });
      panel.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { panel.classList.remove('abierto'); document.body.style.overflow = ''; }); });
    });
  };

  var init = function () {
    document.querySelectorAll('[data-zv-producto]').forEach(initProducto);
    initSticky();
    initPanel();
  };

  window.ZareVont = { init: init, addToCart: addToCart };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
